/*
 * Module for the PROP Account Option step of the PROP Deferral and Distribution form
*/
rs.module("ui/content/communications/onlineforms/propaccountoption",

    [
        "common/select-helper",
        "controls/components/event-banner",
        "common/visibility"
    ],

    function (selectHelper, eventBanner, visibility) {
        // Initialize the module
        function initialize(jsSelectors) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var propAccountOptionRadio = stepContainer.js(jsSelectors.propAccountOptionRadio, { multiple: true });
            var propAccountOptionDescriptionDiv = stepContainer.js(jsSelectors.propAccountOptionDescriptionDiv, { multiple: true });

            var selected = propAccountOptionRadio.filter(":checked");
            var selectedIndex = propAccountOptionRadio.index(selected);
            if (selectedIndex !== null && selectedIndex >= 0) {
                showSelectedPROPAccountOptionDescription(selectedIndex);
            }

            // Handle the propAccountOptionRadio click event
            propAccountOptionRadio.on("click", function () {

                var selectedIndex = propAccountOptionRadio.index(this);
                showSelectedPROPAccountOptionDescription(selectedIndex);
            });

            // Show (slide down) the description for the selected prop account option
            function showSelectedPROPAccountOptionDescription(selectedIndex) {

                // Close all quickly
                propAccountOptionDescriptionDiv.stop(true, true).slideUp(150);

                // Open the selected one
                propAccountOptionDescriptionDiv.eq(selectedIndex).stop(true, true).slideDown(150);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);